import { useState } from "react";
import { Menu, X } from "lucide-react";

const MAILTO = "mailto:cbmr71@gmail.com?subject=Consulta%20SoytuIA";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { label: "Problema", href: "#dolor" },
    { label: "Solución", href: "#modulos" },
    { label: "Credibilidad", href: "#credibilidad" },
    { label: "Contacto", href: "#contacto" },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-[1000] glass-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between" style={{ height: "var(--altura-header)" }}>
        {/* Logo */}
        <a
          href="#"
          data-testid="header-logo"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_ia-concesiones-chile/artifacts/rszkrlc3_soytu_ia_logo_cyan_transparent%20%281%29.svg"
            alt="SoytuIA"
            style={{ height: "60px", width: "auto" }}
            className="block"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.replace("#", "")}`}
              className="text-sm text-white/60 hover:text-white transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href={MAILTO}
            data-testid="header-cta-button"
            className="text-sm px-5 py-2 rounded-full btn-secondary-outline"
          >
            Agenda una llamada
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white/70 hover:text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Nav */}
      {menuOpen && (
        <nav
          data-testid="mobile-nav-menu"
          className="md:hidden glass-surface border-t border-white/5 px-6 py-4 space-y-3"
        >
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="block text-sm text-white/60 hover:text-white py-2"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href={MAILTO}
            className="block text-sm text-center px-5 py-2.5 rounded-full bg-[#FF6B9D] text-white font-semibold hover:bg-[#FF6B9D]/80 mt-2"
            onClick={() => setMenuOpen(false)}
          >
            Agenda una llamada
          </a>
        </nav>
      )}
    </header>
  );
}
